import i18n from "i18next"

export const PACKAGING_DRAFT_STATUS_MESSAGE =
  "A draft cannot change status. Publish the packaging by saving it. Status can be changed only after it is no longer a draft."

export const PACKAGING_LIST_FORBIDDEN_MESSAGE =
  "You don't have access to the packaging list. Ask an admin for the products permission."

export const PACKAGING_WRITE_FORBIDDEN_MESSAGE =
  "You don't have access to save packaging. Ask an admin for the EPR reports permission."

export function packagingDraftStatusMessage() {
  return i18n.t("packagingSku.access.draftStatus", {
    defaultValue: PACKAGING_DRAFT_STATUS_MESSAGE,
  })
}

export function packagingListForbiddenMessage() {
  return i18n.t("packagingSku.access.listForbidden", {
    defaultValue: PACKAGING_LIST_FORBIDDEN_MESSAGE,
  })
}

export function packagingWriteForbiddenMessage() {
  return i18n.t("packagingSku.access.writeForbidden", {
    defaultValue: PACKAGING_WRITE_FORBIDDEN_MESSAGE,
  })
}

export function packagingPermissionMessage(error, kind = "list") {
  const status = Number(error?.status)
  const text = String(error?.message ?? "")
  const forbidden =
    status === 403 || /\b403\b|forbidden|permission denied/i.test(text)
  if (!forbidden) return null
  return kind === "write"
    ? packagingWriteForbiddenMessage()
    : packagingListForbiddenMessage()
}
